<template>
  <div class="number-input clearfix">
    <a-input
      :value="currentVal"
      class="fl"
      @input="handleInput"
    />
    <a class="btn fl">
      <i
        class="iconfont iconicon-test18"
        @click="buttonClick(1)"
      />
      <i
        class="iconfont iconicon-test19"
        @click="buttonClick(-1)"
      />
    </a>
    <span
      v-if="text"
      class="fl text"
    >{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'NumberAddInput',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    maxNum: {
      type: Number,
      default: Math.pow(10, 7) - 1
    },
    minNum: {
      type: Number,
      default: -Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentVal: Number(this.value) || 0
    }
  },
  watch: {
    value (val) {
      this.currentVal = Number(this.value) || 0
    }
  },
  mounted () {
    this.updateVal(this.value)
  },
  methods: {
    handleInput (e) {
      this.fixNumber(e)
    },
    updateVal (val = '') {
      if (val.toString().length > 7) val = val.toString().substring(0, 7)
      if (val > this.maxNum && val.toString().length < 7) val = this.maxNum
      if (val < this.minNum) val = this.minNum
      this.currentVal = val
      this.$emit('change', val)
    },
    buttonClick (flag) {
      if (flag > 0) {
        this.currentVal += Number(this.currentVal) < this.maxNum ? this.step : this.maxNum
        this.updateVal(this.currentVal)
      } else {
        this.currentVal -= Number(this.currentVal) > this.minNum ? this.step : this.minNum
        this.updateVal(this.currentVal)
      }
    },
    fixNumber ($event) {
      let fix
      if (typeof $event.target.value !== 'number') {
        fix = Number($event.target.value.replace(/\D/g, ''))
      } else {
        fix = $event.target.value
      }
      this.updateVal(fix)
    }
  }
}
</script>

<style scoped lang="scss">
.number-input {
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
  user-select: none;
  .ant-input {
    width: 56px;
    border-radius: 4px 0 0 4px;
    border-right: 0;
  }
  .btn {
    position: relative;
    width: 32px;
    height: 32px;
    color: #d6d6d6;
    border: solid 1px #D7D7D7;
    border-radius: 0 4px 4px 0;
    /* &::before {
      content: '';
      position: absolute;
      top: 16px;
      left: 0;
      border-bottom: solid 1px #D8D8D8;
    } */
    .iconfont:first-child{
      position: absolute;
      top: 0px;
      left: 0;
      width: 100%;
      height: 16px;
      line-height: 16px;
      text-align: center;
      border-bottom: solid 1px #D8D8D8;
    }
    .iconfont:last-child{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 16px;
      line-height: 16px;
      text-align: center;
    }
  }
  .text {
    margin-left: 6px;
  }
}
</style>
